module.exports = __webpack_public_path__ + "static/media/img16.d6e67d1a.jpg";